import ReactDOM from 'react-dom/client';
import NewsPostsCarousel from './NewsPostsCarousel';

window.initNewsPostsCarousel = (title, posts, linkToAllNews) => {
  const root = ReactDOM.createRoot(document.getElementById('news-posts-carousel'));
  root.render(<NewsPostsCarousel title={title} posts={posts} linkToAllNews={linkToAllNews} />);
}
